import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { InputFieldComponent } from '../../../../components/ui/inputField/inputField.component';
import { MatIcon } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { AddRecipientModal } from '../../../../components/message-modals/add-recipient/add-recipient';
import { PaginationComponent } from '../../../../components/inputs/pagination/pagination.component';
import { PhoneFrameComponent } from '../../ussd-simulator/phone-frame/phone-frame.component';
import { SecurePersistStateService } from '../../../../services/storage/local-storage.service';
import { Location } from '@angular/common';
import { v4 as uuidv4 } from 'uuid'; // Import uuid for unique ID generation
import { MessageService } from '../../../../services/message/message.service';
import { MessageSubmitButton } from '../../../../components/message-submit-button/message-submit-button.component';
import { UserProfileService } from '../../../../services/user/user-profile.service';
import { ContactsService } from '../../../../services/contacts/contacts.service';

@Component({
  selector: 'message-preview',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule, // Add ReactiveFormsModule here
    FormsModule,
    AddRecipientModal,
    PhoneFrameComponent,
    MessageSubmitButton,
  ],
  templateUrl: './message-preview.component.html',
  styleUrls: ['./message-preview.component.css'],
})
export class MessagePreview implements OnInit {
  submitted: boolean = false;
  isDraft: boolean = false;
  urlparam: number = 0;
  message_subject: string = '';
  message_subjects: string = '';

  constructor(
    private router: Router,
    private localStorageService: SecurePersistStateService,
    private location: Location,
    private messageService: MessageService,
    private route: ActivatedRoute
  ) {}

  userService = inject(UserProfileService);
  contactsService = inject(ContactsService);

  message: any = {};
  recipient: any[] = [];
  recipient_count: number = 0;

  selectedMessageType: string = '';
  selected_zone: string = '';
  selected_date: string = '';
  selected_time: string = '';
  loading: boolean = false;

  get organizationId() {
    return this.userService.organizationId;
  }

  get organizationName() {
    return this.userService.getInstitutionName;
  }

  // Get data from localStorage
  getItem(key: string): any {
    const storedValue = localStorage.getItem(key);
    return storedValue ? JSON.parse(storedValue) : null;
  }

  // Save data to localStorage
  setItem(key: string, data: any): void {
    localStorage.setItem(key, JSON.stringify(data));
  }

  handleEdit() {
    this.location.back();
  }

  deleteMessage() {
    this.messageService.deleteMessage(this.urlparam?.toString()).subscribe({
      next: () => {},
      error: () => {},
      complete: () => {},
    });
  }

  postBody(status: 'Completed' | 'Draft' | 'Pending') {
    const uniqueId = uuidv4();
    const date = new Date();

    // selected_segments: this.selected_segments,

    const stateContacts = (this.getItem('formState')?.selected_contacts ?? []) as any[];
    const message_subject = this.getItem('formState')?.message_subject;
    const selected_organisation = (this.getItem('formState')
      ?.selected_organisation ?? []) as any[];
    const selected_tags = (this.getItem('formState')?.selected_tags ?? []) as any[];
    const selected_segments = (this.getItem('formState')
      ?.selected_segments ?? []) as any[];
    const message = this.getItem('preivew');
    const selectedTemplate = this.getItem('formState').selectedTemplate;
    const messageType = this.getItem('formState').selectedMessageType;
    const selected_zone = this.getItem('formState').selected_zone;
    const schedule_date = this.getItem('formState').schedule_date;
    const schedule_time = this.getItem('formState').schedule_time;
    const mapContacts = stateContacts.map((res) => ({
      contactUuids: res?.uuid,
    }));

    const mapTags = selected_tags.map((res) => ({ tagUuids: res.uuid }));

    const selectOrg = selected_organisation.map((res) => ({
      companyUuids: res.uuid,
    }));

    const selectSeg = selected_segments.map((res) => ({
      segmentUuids: res.uuid,
    }));

    return {
      flash: false,
      from: this.organizationName,
      intermediateReport: true,
      content: message.value,
      uuid: uniqueId,
      sendAt: date.toISOString(),
      createdAt: date.toISOString(),
      countryCode: 'SG',
      organisationId: this.organizationId,
      messageSubject: message_subject,
      messageTemplate: selectedTemplate,
      messageType: messageType === 'schedule' ? 'SCHEDULE' : 'INSTANT',
      status: messageType === 'schedule' ? 'Pending' : status,
      scheduleTimeZone: messageType === 'schedule' ? selected_zone : '',
      scheduleDate: messageType === 'schedule' ? new Date(schedule_date) : '',
      scheduleDime: messageType === 'schedule' ? schedule_time : '',
      engagementContactLists: [
        ...mapContacts,
        ...mapTags,
        ...selectOrg,
        ...selectSeg,
      ],
    };
  }

  postBodyUpdate(status: 'Completed' | 'Draft' | 'Pending') {
    const uniqueId = uuidv4();
    const date = new Date();

    // selected_segments: this.selected_segments,

    const stateContacts = (this.getItem('formState')?.selected_contacts ?? []) as any[];
    const message_subject = this.getItem('formState')?.message_subject;
    const selected_organisation = (this.getItem('formState')
      ?.selected_organisation ?? []) as any[];
    const selected_tags = (this.getItem('formState')?.selected_tags ?? []) as any[];
    const message = this.getItem('preivew');
    const selectedTemplate = this.getItem('formState').selectedTemplate;
    const messageType = this.getItem('formState').selectedMessageType;
    const selected_zone = this.getItem('formState').selected_zone;
    const schedule_date = this.getItem('formState').schedule_date;
    const schedule_time = this.getItem('formState').schedule_time;
    const mapContacts = stateContacts.map((res) => ({
      contactUuids: res?.uuid,
    }));

    const mapTags = selected_tags.map((res) => ({ tagUuids: res.uuid }));

    const selectOrg = selected_organisation.map((res) => ({
      companyUuids: res.uuid,
    }));

    return {
      id: this.urlparam,
      flash: false,
      from: this.organizationName,
      intermediateReport: true,
      content: message.value,
      uuid: uniqueId,
      sendAt: date.toISOString(),
      createdAt: date.toISOString(),
      countryCode: 'SG',
      organisationId: this.organizationId,
      messageSubject: message_subject,
      messageTemplate: selectedTemplate,
      messageType: messageType === 'schedule' ? 'SCHEDULE' : 'INSTANT',
      status: messageType === 'schedule' ? 'Pending' : status,
      scheduleTimeZone: messageType === 'schedule' ? selected_zone : '',
      scheduleDate: messageType === 'schedule' ? new Date(schedule_date) : '',
      scheduleTime: messageType === 'schedule' ? schedule_time : '',
      // engagementContactLists: [...mapContacts, ...mapTags, ...selectOrg],
    };
  }

  handleDraft() {
    this.submitted = true;

    if (this.urlparam) {
      this.deleteMessage();
    }
    this.messageService.createMessage(this.postBody('Draft')).subscribe({
      next: () => {
        // Clear formState from localStorage
        localStorage.removeItem('formState');
        this.router.navigate(['/organization/messages'], { queryParams: { tab: 'inactive' } });
        this.submitted = false;
      },
      error: (err) => {
        this.submitted = false;
      },
    });

    this.messageService.loading.subscribe((loading) => {
      this.loading = loading;
    });
  }

  handleSubmit() {
    this.submitted = true;

    const contacts = this.getItem('formState')?.selected_contacts as any[];
    const message = this.getItem('preivew');
    const subject = this.getItem('formState')?.message_subject;

    if (message?.value !== '' && contacts?.length !== 0 && subject !== '') {
      // const mapTags = this.selected_tags.map((res) => res.id);
      // const mapSegments = this.selected_segments.map((res) => res.id);

      if (this.urlparam) {
        this.deleteMessage();
      }
      this.messageService.createMessage(this.postBody('Completed')).subscribe({
        next: () => {
          // Clear formState from localStorage
          localStorage.removeItem('formState');
          this.router.navigate(['/organization/messages']);
          this.submitted = false;
        },
        error: (err) => {
          this.submitted = false;
        },
      });

      this.messageService.loading.subscribe((loading) => {
        this.loading = loading;
      });
    } else {
      this.submitted = false;
    }
  }

  // handleSubmit() {
  //   const data = {
  //     id: uuidv4(), // Assign a unique ID
  //     message_name: uuidv4(),
  //     status: 'Completed',
  //     date_created: new Date().toISOString(),
  //     contacts: this.getItem('formState')?.selected_contacts,
  //     message: this.getItem('preivew'),
  //     date_launched: '-',
  //     date_scheduled: this.getItem('formState')?.schedule_date,
  //     created_by: 'Admin',
  //     message_type: this.getItem('formState')?.selectedMessageType,
  //     schedule: {
  //       zone: this.getItem('formState')?.selected_zone,
  //       date: this.getItem('formState')?.schedule_date,
  //       time: this.getItem('formState')?.schedule_time,
  //     },
  //   };

  //   // Retrieve the current list from localStorage or initialize an empty array
  //   const currentData = this.getItem('messages') || [];
  //   // Append the new data
  //   currentData.push(data);
  //   // Save the updated list back to localStorage
  //   this.setItem('messages', currentData);

  //   // Clear formState data from localStorage
  //   localStorage.removeItem('formState');

  //   // Redirect to '/organization/messages'
  //   this.router.navigate(['/organization/messages']);
  // }

  setDraft() {
    this.isDraft = true;
  }

  discard() {
    this.isDraft = false;
    this.router.navigate(['/organization/messages']);
  }
  closeDraft() {
    this.isDraft = false;
  }

  fetchSegmentsBulk(data: string[]): void {
    if (data.length) {
      this.contactsService.fetchBulkSegments({
        'uuid.in': data,
      });

      this.contactsService.getBulkSegments.subscribe({
        next: () => {},
        error: (err) => {
        },
      });
    }
  }

  ngOnInit() {
    // Opened without a saved draft (directly, refreshed after sending, or with the
    // browser's storage cleared): there is nothing to preview, so start a new message.
    if (!this.getItem('formState') || !this.getItem('preivew')) {
      this.router.navigate(['/organization/messages/create'], { replaceUrl: true });
      return;
    }

    this.message = this.getItem('preivew');
    this.message_subjects = this.getItem('formState')?.message_subject;
    this.recipient = this.getItem('formState')?.selected_contacts;
    this.selectedMessageType = this.getItem('formState')?.selectedMessageType;
    this.selected_zone = this.getItem('formState')?.selected_zone;
    this.selected_date = this.getItem('formState')?.schedule_date;
    this.selected_time = this.getItem('formState')?.schedule_time;

    // A list the draft does not have counts as empty.
    const selectedContact = this.getItem('formState')?.selected_contacts ?? [];
    const selectedTags = this.getItem('formState')?.selected_tags ?? [];
    const selectedSegments = this.getItem('formState')?.selected_segments ?? [];
    const selectedOrganization =
      this.getItem('formState')?.selected_organisation ?? [];

    this.recipient_count = [
      ...selectedContact,
      ...selectedTags,
      ...selectedSegments,
      ...selectedOrganization,
    ]?.length;

    this.route.queryParams.subscribe((params) => {
      this.urlparam = params['payload'];
    });
  }
}
